{
  "title": "Kazakhtelecom — your partner in the business world",
  "description": "Internet and telephony from JSC Kazakhtelecom. Labeling, FDO, digital services, and IT solutions for business.",
  "Частным лицам": "For individuals",
  "Бизнесу": "For business",
  "Ещё": "More",
  "О компании": "About the company",
  "Гос. заказчикам": "For government clients",
  "Корпоративным клиентам": "For corporate clients",
  "Операторам": "For operators",
  "Партнёрам": "To partners",
  "Вопросы по ОФД, Маркировке, КГД": "Questions about FDO, labeling, and SRC",
  "Справочный центр": "Help center",
  "Подключить": "Connect",
  "Оплата за услуги": "Pay for services",
  "Поддержка": "Support",
  "Домены": "Domains",
  "Починить интернет": "Fix internet connection",
  "Личный кабинет": "Personal account",
  "Пакеты услуг для бизнеса": "Business service packages",
  "Для ИП и самозанятых": "For sole proprietors and self-employed",
  "Для юридических лиц": "For legal entities",
  "Как подключить услугу": "How to activate a service",
  "Выберите услугу": "Choose a service",
  "Проверим адрес": "We'll check your address",
  "Подключим услугу": "We'll activate the service",
  "Оставьте заявку\nна подключение": "Submit a сonnection request",
  "Подтвердим\nдоступность по адресу": "We'll confirm availability at your address",
  "Выполним установку\nи настройку": "We'll perform installation and configuration",
  "Сервисы для бизнеса": "Business services",
  "Телевидение нового поколения для бизнеса": "Next-generation TV for business",
  "Ваш бизнес в одной ссылке": "Your business in one link",
  "Соберите контакты, соцсети, сайт и предложения в одну страницу, которой удобно делиться с клиентами": "Share contacts, social links, your website, and offers through a single page made for clients",
  "Создать страницу": "Create page",
  "Простое подключение, богатый выбор контента": "Easy setup, wide content selection",
  "Все сервисы": "All services",
  "Создайте свою link in bio\nстраницу": "Create your own link in bio page",
  "Новости и обновления": "News and updates",
  "Все новости": "All news",
  "Интернет": "Internet",
  "IT-Решения": "IT Solutions",
  "Маркировка": "Product labeling",
  "Облачные и цифровые\nсервисы, аренда серверов,\nхостинг, IT-услуги": "Cloud and digital services, server rental, hosting, IT Services",
  "Маркировка кодом Data Matrix": "Data Matrix Code labeling",
  "Подписывайте,\nотправляйте\nи получайте\nдокументы онлайн": "Sign, send, and receive documents online",
  "Облачная среда\nдля AI-технологий на базе\nNVIDIA H200": "Cloud environment for AI technologies powered by NVIDIA H200",
  "ОФД": "Fiscal Data Operator",
  "Решение для фискального учёта": "Solution for fiscal accounting",
  "Сервис сокращения ссылок": "Link shortening service",
  "Поддержка стартапов\nи компаний": "Support for startups and companies",
  "Перейти на сайт": "Go to website",
  "Документы": "Documents",
  "Сократить ссылку": "Shorten link",
  "Услуги": "Services",
  "Проекты": "Projects",
  "Помощь и поддержка": "Help and support",
  "Заказать звонок": "Request a call",
  "Офисная связь": "Voice services",
  "Служба поддержки": "Help desk",
  "Колл-центр": "Call center",
  "Адреса и реквизиты": "Addresses and details",
  "Телевидение": "Television",
  "IT и безопасность": "IT and security",
  "Новости": "News",
  "Строительство сети": "Network construction",
  "Оплата": "Payment",
  "АО «Казахтелеком». Все права защищены": "Kazakhtelecom, JSC. All rights reserved",
  "АО «Казахтелеком».\nВсе права защищены": "Kazakhtelecom, JSC.\nAll rights reserved",
  "Договор оферты": "Offer agreement",
  "Публичный договор": "Public agreement",
  "Выбор клиентов": "Customer choice",
  "/ мес": "/ month",
  "Интернет по оптике": "Fiber internet",
  "{speed} Мбит / сек входящая скорость": "{speed} Mbps download speed",
  "{speed} Мбит / сек исходящая скорость": "{speed} Mbps upload speed",
  "100+ телеканалов": "100+ TV channels",
  "2 онлайн кинорума": "2 online cinemas",
  "Связь": "Communication",
  "Телефония": "Telephony",
  "SIP-телефония": "SIP telephony",
  "Мобильная связь": "Mobile",
  "5 000 минут на междугородние и городские номера по РК": "5,000 minutes to landline and long-distance numbers across Kazakhstan",
  "1 000 минут звонков на Altel / Tele2": "1,000 minutes to Altel / Tele2",
  "Безлимитные звонки на Altel / Tele2": "Unlimited calls to Altel / Tele2",
  "6 000 минут на междугородние и городские номера по РК": "6,000 minutes to landline and long-distance numbers across Kazakhstan",
  "800 минут звонков на Kcell / Beeline": "800 minutes to Kcell / Beeline",
  "400 минут звонков на Kcell / Beeline": "400 minutes to Kcell / Beeline",
  "40 GB мобильного интернет трафика": "40 GB of mobile data",
  "20 GB мобильного интернет трафика": "20 GB of mobile data",
  "Бесплатный трафик на WhatsApp, Facebook, Telegram": "Free traffic for WhatsApp, Facebook, Telegram",
  "Антивирус": "Antivirus",
  "Антивирус для ПК": "Antivirus for PC",
  "Антивирус для мобильных устройств": "Antivirus for mobile",
  "Антиспам Who Calls": "Who Calls spam protection",
  "Видеонаблюдение": "Video surveillance",
  "1 500 минут звонков на Altel / Tele2": "1,500 minutes to Altel / Tele2",
  "16 дополнительных услуг связи": "16 additional communication services",
  "Каталог услуг": "Service catalog",
  "Войти": "Sign in",
  "Вход и регистрация": "Sign in and sign up",
  "ЦЭДМ": "CEDM",
  "НКТ": "NPC",
  "НСПТ": "NPTS",
  "Подробнее": "Learn more",
  "Выбрать услугу": "Choose a service",
  "Интернет для бизнеса": "Internet for business",
  "Интернет для игровых клубов": "Internet for gaming clubs",
  "Wi-Fi target": "Wi-Fi target",
  "FXS — Городской телефон по оптическому кабелю": "FXS — landline phone over fiber optic cable",
  "Универсальный номер для мобильного бизнеса": "Universal number for mobile business",
  "Голосовой робот-помощник": "Voice assistant robot",
  "Видеонаблюдение IMOU": "Video Surveillance IMOU",
  "Видеонаблюдение для ПВЗ Wildberries": "Video surveillance for Wildberries pickup points",
  "TV+ business": "TV+ business",
  "Приватная сеть IP VPN": "Private IP VPN network",
  "Защита от DDoS-атак": "DDoS protection",
  "Интернет с доступом к кэш-серверам": "Internet with access to cache servers",
  "Интернет-пиринг": "Internet peering",
  "Электронный документооборот для бизнеса": "Electronic document management for business",
  "Получение технических условий": "Obtaining technical specifications",
  "Cтаньте партнёром АО «Казахтелеком»": "Become a partner of JSC Kazakhtelecom",
  "Личный кабинет корпоративного клиента": "Business Account",
  "Мобильное приложение": "Mobile App",
  "Отправить один бумажный документ курьером — дороже, чем месяц подписки на Telecom Docs": "Sending a single paper document by courier costs more than a month of Telecom Docs subscription",
  "Облачная среда для AI-технологий на базе NVIDIA H200. Вычислительные мощности внутри Казахстана": "Cloud environment for AI technologies based on NVIDIA H200. Computing power within Kazakhstan",
  "Попробовать бесплатно": "Try for free",
  "Начать работу": "Get started",
  "О сервисе": "About the service",
  "Скачайте приложение": "Download the app",
  "Отсканируйте QR-код камерой телефона": "Scan the QR code with your phone’s camera",
  "Скачайте наше приложение": "Download our app!",
  "Отсканируйте QR-код с помощью камеры вашего устройства или нажмите кнопку ниже, чтобы перейти в магазин приложений": "Scan the QR code with your device's camera or click the button below to go to the app store",
  "Скачать приложение": "Download the app",
  "ОФД Казахтелеком": "Fiscal data operator",
  "Настройки аккаунта": "Account settings",
  "Управление компаниями": "Company management",
  "banner": {
    "docs": {
      "title": "Try Telecom Docs for free",
      "description": "Send 3 documents for free, no card input or subscriptions required",
      "button": "Start for free"
    }
  },
  "Цифровые сервисы": "Digital services",
  "Инфраструктура дронов под ключ": "Turnkey drone infrastructure",
  "Цифровой сервис телемедицины": "Digital telemedicine service",
  "Смарт-видеожетоны": "Smart body cameras",
  "Умные остановки": "Smart bus stops",
  "Интернет вещей (IoT)": "Internet of Things (IoT)",
  "ИИ-агенты для бизнеса": "AI agents for business",
  "Baylanis — платформа видеоконференций": "Baylanis — video conferencing platform",
  "ИИ для анализа КТ головного мозга": "AI for brain CT scan analysis",
  "Облачные сервисы": "Cloud services",
  "Объектное хранилище S3": "S3 object storage",
  "Виртуальный хостинг": "Web hosting",
  "Виртуальный выделенный сервер (VPS)": "Virtual private server (VPS)",
  "Домены .KZ .ҚАЗ": ".KZ and .ҚАЗ domains",
  "Виртуальный дата-центр (VDC)": "Virtual data center (VDC)",
  "Сервисы ЦОД": "Data center services",
  "Размещение оборудования (Colocation)": "Equipment hosting (Colocation)",
  "Аренда серверной стойки (Rent a rack)": "Server rack rental (Rent a Rack)",
  "Развитие бизнеса": "Business Development",
  "Все услуги": "All services",
  "Вход и регистрация": "Sign in / Sign up",
  "Выберите товарную группу": "Select a product group",
  "Производители, импортёры": "Manufacturers and importers",
  "Оптовые реализаторы, аптеки, медицинские организации": "Wholesale distributors, pharmacies, and healthcare organizations",
  "Обувная продукция": "Footwear",
  "Вход в ИС МПТ": "Sign in to PLTIS",
  "Заказ кодов, формирование отчёта о нанесении и агрегации": "Order codes and submit code application and aggregation reports",
  "Вход в ИС ЭТ (Информационная система экспорта товаров)": "Sign in to GEIS (Goods Export Information System)",
  "Заказ кодов, формирование отчёта о нанесении, работа с документами": "Order labeling codes, submit code application reports, and work with documents.",
  "Вход в ЦЭДМ": "Sign in to EDMC",
  "Работа с документами прослеживаемости": "Manage traceability documents",
  "Сервис по автовыбытия": "Automatic Withdrawal Service",
  "Для розничных реализаторов с автоматическим выбытием": "For retailers using automatic withdrawal from circulation.",
  "Регистрация в ИС МПТ": "Sign up for PLTIS",
  "Для регистрации в системе требуется ЭЦП и установленный NCALayer": "You'll need an EDS and NCALayer installed to sign up",
  "Регистрация на b2b.telecom.kz": "Sign up on b2b.telecom.kz",
  "Работа с бухгалтерскими документами": "Manage accounting documents",
  "Тестовая работа в ИС МПТ": "Try PLTIS in the test environment",
  "Аппробация процессов маркировки в ИС МПТ: регистрация карточки товара, получение кодов, работа с документами прослеживаемости товара": "Test marking workflows in PLTIS: create a product card, obtain codes, and manage product traceability documents",
  "Бесплатно с мобильных и городских номеров": "Toll-free from mobile phones and landlines",
  "Помощник в Telegram": "Get help on Telegram",
  "Помощник в WhatsApp": "Get help on WhatsApp",
  "Лекарственные препараты": "Pharmaceuticals",
  "Табачные изделия": "Tobacco products",
  "Товары лёгкой промышленности": "Light industry products",
  "Моторные масла": "Motor oils",
  "Вход в систему": "Sign in",
  "Вход в тестовую систему": "Sign in to the test environment",
  "Ювелирные изделия": "Jewelry",
  "Пиво и пивные напитки": "Beer and beer-based beverages",
  "Биологически активные добавки": "Dietary supplements",
  "Бытовая химия": "Household cleaning products",
  "Газовые баллоны": "Gas cylinders",
  "Растительное масло": "Vegetable oil",
  "Древесина": "Timber",
  "Изделия медицинского назначения": "Medical devices",
  "Дериваты сайгаков": "Saiga derivatives",
  "Оплата по QR на столе, заказы и бронирование": "Orders, reservations and QR payments",
  "Подключите Halyk Рестораны без абонентской платы и обслуживайте гостей быстрее": "Connect to Halyk Restaurants with no subscription fee and serve your guests faster",
  "Узнать о сервисе": "Learn more",
  "Магазинам и аптекам\nвыгоднее с OnlineDuken": "Stores and pharmacies choose OnlineDuken",
  "Заказывайте товары у проверенных поставщиков, получайте до 50 000 бонусов в месяц, оплачивайте покупку сразу или с отсрочкой на сумму до 5 млн ₸": "Order from trusted suppliers, earn up to 50,000 bonus points a month, and pay now or later with up to ₸5 million in deferred payment.",
  "Оставить заявку": "Apply",
  "Интернет для платёжных терминалов PayNet": "Internet for PayNet payment terminals",
  "Стабильное подключение для работы платёжных терминалов": "Reliable connectivity for payment terminals",
  "Интернет для платёжных терминалов PayNet": "Internet for PayNet payment terminals",
  "Пакетные решения": "Bundled Plans",
  "Kasipker — пакеты связи для ИП": "Kasipker: Bundles for Sole Proprietors",
  "Скоро": "Coming Soon"
}